import React from "react";
import { Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Home from "../pages/Home";

import { useAuth } from "../Context/authContext";

import { PublicRoutes } from "./PublicRoutes";

import { ProtectedRoutes } from "./ProtectedRoutes";
import SignIn from "../components/Auth/SignIn";
import SignUp from "../components/Auth/SignUp";
import UploadPage from "../components/Upload";
import Search from "../components/SearchPage";
import AssetDetails from "../components/AssetDetailsPage";
import getCookie, { AuthToken } from "../components/Common/Utils";
import ScrollToTop from "../components/Common/ScrollPage";
import { AppLayout } from "../layouts/AppLayout";
import LoginPage from "../components/Auth/LoginPage";
// const isAuthenticated = () => getCookie("detection_auth");
function Routes() {
  const { user } = useAuth();
  let element = useRoutes([
    {
      path: "/",
      // element: AuthToken.isValid() ? (
      //   <AppLayout>
      //     <UploadPage />
      //   </AppLayout>
      // ) : (
      //   <Home />
      // ),
      element: user ? (
        <AppLayout>
          <UploadPage />
        </AppLayout>
      ) : (
        <Home />
      ),
    },
    {
      element: <PublicRoutes />,
      children: [
        {
          path: "/signin",
          element: <SignIn />,
          // element: AuthToken.isValid() ? (
          //   <Navigate to="/" replace />
          // ) : (
          //   <SignIn />
          // ),
        },
        {
          path: "/signup",
          // element: AuthToken.isValid() ? (
          //   <Navigate to="/" replace />
          // ) : (
          //   <SignUp />
          // ),
          element: <SignUp />,
        },
        {
          path: "/login",
          // element: AuthToken.isValid() ? (
          //   <Navigate to="/" replace />
          // ) : (
          //   <SignUp />
          // ),
          element: <LoginPage />,
        },

        {
          path: "*",
          element: <Navigate to="/" replace />,
        },
      ],
    },
    {
      element: <ProtectedRoutes />,
      children: [
        {
          element: <AppLayout />,
          children: [
            { path: "/search", element: <Search /> },
            {
              path: "/search/:id",
              element: <AssetDetails />,
            },
            {
              path: "/:id",
              element: <UploadPage />,
            },
            {
              path: "*",
              element: user ? <UploadPage /> : <SignIn />,
            },
          ],
        },
      ],
    },
  ]);
  return element;
}

const Router = () => {
  return (
    <ScrollToTop>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes />
      </Suspense>
    </ScrollToTop>
  );
};

export default Router;
